import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './styles.css';


const Banner = (props) => {

  const bannerClass = classnames('gdocs-banner', {
    'gdocs-banner--warning': props.bannerType === 'warning',
    'gdocs-banner--primary': props.bannerType === 'primary'
  });

  const iconClass = classnames('icon', 'gdocs-banner__icon', {
    [props.iconClass + ' gdocs-banner__icon--warning']: props.bannerType === 'warning',
    [props.iconClass + ' gdocs-banner__icon--primary']: props.bannerType === 'primary',
  });

  return (props.hide !== true ? (
    <div className={bannerClass}>
      <div className={props.bannerId}>
        <i className={iconClass} role={iconClass.includes('gdocs-banner__icon--primary') ? 'img' : null} aria-label={iconClass.includes('gdocs-banner__icon--primary') ? 'Advisory Text' : null}></i>
        <span className="gdocs-banner__content" id={props.bannerType + '_' + props.bannerId}>{props.children}</span>
      </div>
      {props.notificationTxt2 ?
        <div>
          <i className={iconClass}></i>
          <span className="gdocs-banner__content" id={props.bannerType + '_' + props.bannerId}>{props.notificationTxt2}</span>
        </div>
        : null}
      <button
        className="gdocs-banner__action-text"
        onClick={() => typeof props.actionCallback === "function" && props.actionCallback(props.bannerId)}
        tabIndex={props.actionText ? null : -1}
      >
        {props.actionText}
      </button>
    </div>
  ) : '');
}

Banner.defaultProps = {
  iconClass: 'icon-circle-error-solid'
}

Banner.propTypes = {
  bannerType: PropTypes.string.isRequired,
  iconClass: PropTypes.string
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/common/Banner/index.js